// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3VTRs","footer":"ModalFilter_footer__2pRMy"};